module.exports = __webpack_public_path__ + "img/consultoria_9-16_360.429b9814.webp";